import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-425cb73b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-4" }
const _hoisted_2 = { class: "box max-w-xl mx-auto p-4" }
const _hoisted_3 = { class: "flex flex-col items-center justify-center" }
const _hoisted_4 = { class: "flex items-center justify-center" }
const _hoisted_5 = { class: "relative w-60 input-component mt-12" }
const _hoisted_6 = { class: "flex flex-col items-center justify-center mt-4" }
const _hoisted_7 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputWhere = _resolveComponent("InputWhere")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("my_linked_clubs")), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t("automatic_link", { user_email: _ctx.userEmail })), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_InputWhere, {
            placeholder: _ctx.$t('search_a_club_to_link'),
            onlyOneSelect: true,
            allowNearMe: false,
            allowFavorites: false,
            onSendTenantToBooking: _ctx.tenantSelected
          }, null, 8, ["placeholder", "onSendTenantToBooking"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", null, _toDisplayString(_ctx.messageTitle), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.message), 1)
      ])
    ])
  ]))
}